'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateField = validateField;
exports.phoneNumber = phoneNumber;
exports.minLength = minLength;
exports.email = email;
var REGEX_PHONE_NUMBER = /^(\+7)[\s][\(](9)(\d{2})[\)][\s][\d]{3}[\s][\d]{2}[\s][\d]{2}$/;
var REGEX_EMAIL = /^([a-z0-9_-]+\.)*[a-z0-9_-]+@[a-z0-9_-]+(\.[a-z0-9_-]+)*\.[a-z]{2,6}$/;

function validateField(value, validateType) {
    var _Validators;

    switch (validateType) {
        case ATTRIBUTE_VALIDATOR_PHONE:
            for (var _len = arguments.length, params = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
                params[_key - 2] = arguments[_key];
            }

            return (_Validators = Validators).phoneNumber.apply(_Validators, [value].concat(params));
            break;
    }
}

/**
 * Валидация номера телефона
 *
 * @param {String} phone
 *
 * @return {boolean}
 */
function phoneNumber(phone) {
    return REGEX_PHONE_NUMBER.test(phone);
}

/**
 * Валидация длины строки на минимальное кол-во символов
 *
 * @param {String} string
 * @param {int} minLength
 *
 * @return {boolean}
 */
function minLength(string) {
    var minLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;

    return string.length >= minLength;
}

/**
 * Валидация почтового ящика
 *
 * @param {String} email
 *
 * @return {bool}
 */
function email(email) {
    return REGEX_EMAIL.test(email);
}


//////////////////
// WEBPACK FOOTER
// ./src/components/PassRecovery/Validators.js
// module id = 1729
// module chunks = 0